import { motion } from 'framer-motion';
import { Quote, Star } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
const FeaturedTestimonial = () => {
  const navigate = useNavigate();
  return <section className="py-20 bg-gradient-to-b from-[#1d1d1d] to-[#191919] relative overflow-hidden">
      {/* Decorative background elements with smoother gradients */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-chrona-accent/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-chrona-accent/3 rounded-full blur-2xl"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-6xl mx-auto">
          <motion.div className="grid grid-cols-1 lg:grid-cols-5 gap-8 items-center" initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} transition={{
          duration: 0.6
        }} viewport={{
          once: true
        }}>
            {/* Left Column - Image */}
            <motion.div className="lg:col-span-2 rounded-2xl overflow-hidden" initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} viewport={{
            once: true
          }}>
              <div className="relative aspect-[4/5] rounded-2xl overflow-hidden border border-[#333]/50 shadow-lg">
                <img src="/lovable-uploads/e799ff9c-7b31-416f-b81e-593b801b4509.png" alt="Beauty Studio Showcase" className="absolute inset-0 w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <div className="flex items-center mb-1">
                    {[1, 2, 3, 4, 5].map(star => <Star key={star} className="h-4 w-4 fill-chrona-accent text-chrona-accent" />)}
                  </div>
                  <h3 className="text-xl font-semibold text-white">Beauty Studio Berlin</h3>
                  <p className="text-sm text-[#F8F8F8]/80">Seit 2022 auf CHRONA</p>
                </div>
              </div>
            </motion.div>
            
            {/* Right Column - Quote with improved contrast */}
            <motion.div className="lg:col-span-3 bg-[#151515]/70 backdrop-blur-md p-8 rounded-2xl relative border border-[#F8F8F8]/10 shadow-lg" initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.5,
            delay: 0.4
          }} viewport={{
            once: true
          }}>
              <Quote className="absolute top-4 left-4 h-10 w-10 text-chrona-accent opacity-20" />
              <div className="pt-8">
                <blockquote className="text-xl md:text-2xl font-medium mb-8 text-[#F8F8F8]">
                  "Seit wir CHRONA nutzen, hat sich unsere Buchungsrate um 40% erhöht. 
                  Die Plattform ist nicht nur für unsere Kunden ein Traum, sondern erleichtert
                  auch uns als Studio die tägliche Arbeit erheblich."
                </blockquote>
                <div className="mb-8">
                  <p className="font-semibold text-chrona-accent text-lg">Sarah Müller</p>
                  <p className="text-[#F8F8F8]/70">Inhaberin, Beauty Studio Berlin</p>
                </div>
                <div className="flex flex-wrap gap-4">
                  <Button onClick={() => navigate('/booking')} className="bg-chrona-accent hover:bg-chrona-accent-light text-white">
                    Studio besuchen
                  </Button>
                  <Button variant="outline" onClick={() => navigate('/register?type=studio')} className="border-[#333] bg-[chrona-accent-dark] text-[chrona-accent-dark] bg-inherit text-white">
                    Als Studio registrieren
                  </Button>
                </div>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
};
export default FeaturedTestimonial;